<script lang="ts" setup>
import underReviewIcon from '@images/svg/under-review.svg';

defineProps({
    jobs: {
        type: Array,
        default: () => []
    },
    isLoading: {
        type: Boolean,
        default: false
    }
})

const { t } = useI18n()
</script>

<template>
    <VRow>
        <template v-if="isLoading">
            <VCol v-for="i in 6" :key="'skeleton-' + i" cols="12" md="6" lg="4">
                <VSkeletonLoader height="130" elevation="1" />
            </VCol>
        </template>

        <template v-else-if="jobs.length > 0">
            <VCol v-for="job in jobs" :key="job.id" cols="12" md="6" lg="4">
                <JobCard :job="job" />
            </VCol>
        </template>

        <VCol v-else cols="12" class="text-center mt-10">
            <Component :is="underReviewIcon" />
            <p class="text-h5 mt-4">
                {{ t('No Matching Jobs Found.') }}
            </p>
            <p>{{ t("We couldn't find what you searched for.") }}</p>
        </VCol>
    </VRow>
</template>

<style lang="scss" scoped></style>
